import _ from 'lodash'

import type {
  PrebidModuleInternalValuesDTO,
  PrebidModuleValuesDTO,
} from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'
import type {
  AbTestOption,
  ItemValue,
  PrebidModulesItem,
} from 'features/ab-tests/types/abTestParametersSchema'

export const prebidModuleFromDTO = (
  module: PrebidModuleValuesDTO,
): AbTestOption & PrebidModulesItem => ({
  ..._.chain(module.items)
    .keyBy('id')
    .mapValues(
      ({ label }: PrebidModuleInternalValuesDTO): ItemValue => ({
        label,
      }),
    )
    .value(),
  label: module.label,
})
